import { FC } from 'react'
import styled from 'styled-components'

import {
  Accessories,
  LabCoat,
  Outerwear,
  ScrubCap,
  ScrubPants,
  ScrubTop,
  Socks,
  Underscrubs,
} from '@syconium/little-miss-figgy'

import { normalizeCategoryFilter } from '../BulkPage'

import { CategoryName, CategoryQuantity, QuantityNameWrapper } from './styles'

type Props = {
  ctaText: string
  category: string
  quantity: number
}

const CATEGORY_ICON_MAP = {
  'Scrub Top': ScrubTop,
  'Scrub Pants': ScrubPants,
  'Underscrub': Underscrubs,
  'Outerwear': Outerwear,
  'Socks': Socks,
  'Scrub Cap': ScrubCap,
  'Accessories': Accessories,
  'Lab Coat': LabCoat,
} as const

const StyledIcon = styled.div<{ hasItems: boolean }>`
  svg {
    fill: ${({ theme, hasItems }) =>
      hasItems ? theme.color.stroke.neutral.text.primary : theme.color.deprecated.stone};
  }
`

const getIcon = (category: string) => {
  const normalizedCategory = normalizeCategoryFilter(category)
  const IconComponent = Object.entries(CATEGORY_ICON_MAP).find(
    ([key]) => normalizeCategoryFilter(key) === normalizedCategory
  )?.[1]

  return IconComponent ? <IconComponent /> : null
}

export const CategoryIcon: FC<Props> = ({ ctaText, category, quantity }) => {
  const hasItems = quantity !== 0
  const icon = getIcon(category)

  if (!icon) return null

  return (
    <>
      <StyledIcon hasItems={hasItems}>{icon}</StyledIcon>
      <QuantityNameWrapper>
        <CategoryName>{ctaText}</CategoryName>
        <CategoryQuantity>{quantity}</CategoryQuantity>
      </QuantityNameWrapper>
    </>
  )
}
